import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .PartnershipIBTreeTable {
    background: white;
    border-radius: 12px;
    overflow-x: auto;
    margin-top: 16px;
  }

  .PartnershipIBTreeTable__wrapper {
    min-width: 900px;
  }

  .PartnershipIBTreeTable__HeaderRow {
    display: grid;
    grid-template-columns: 2fr 1.2fr 1fr 1fr 1fr 0.8fr;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 16px;
  }

  .PartnershipIBTreeTable__HeaderCell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 8px;
    font-size: 12px;
    color: #888;
    font-weight: 400;
  }

  .PartnershipIBTreeTable__HeaderTop {
    font-size: 13px;
    color: #333;
    font-weight: 600;
    margin-bottom: 2px;
  }

  .PartnershipIBTreeTable__HeaderLabel {
    font-size: 11px;
    color: #999;
    margin-top: 2px;
  }

  .PartnershipIBTreeTable__Row {
    display: grid;
    grid-template-columns: 2fr 1.2fr 1fr 1fr 1fr 0.8fr;
    align-items: center;
    padding: 0 16px;
    transition: background 0.15s;
    cursor: pointer;
    min-height: 52px;
  }

  .PartnershipIBTreeTable__Row:not(:last-child) {
    border-bottom: 1px solid #f3f3f3;
  }

  .PartnershipIBTreeTable__Row--ib {
    background: #f0ead6;
    font-weight: 500;
  }

  .PartnershipIBTreeTable__Row--ib:hover {
    background: #e8dfbf;
  }

  .PartnershipIBTreeTable__Row--user:hover {
    background: #fafafa;
  }

  .PartnershipIBTreeTable__Cell {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    font-size: 14px;
    color: #333;
  }

  .PartnershipIBTreeTable__Cell--name {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .PartnershipIBTreeTable__ExpandBtn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    color: #555;
    line-height: 1;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
    flex-shrink: 0;
  }

  .PartnershipIBTreeTable__ExpandBtn--open {
    transform: rotate(90deg);
  }

  .PartnershipIBTreeTable__IBLabel {
    font-size: 11px;
    color: #888;
    font-weight: 400;
    margin-left: 4px;
  }

  .PartnershipIBTreeTable__Empty {
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-size: 14px;
  }

  .PartnershipIBTreeTable__Pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    padding: 12px 16px;
    border-top: 1px solid #e8e8e8;
    min-width: 900px;
  }

  .PartnershipIBTreeTable__PageInfo {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #555;
  }

  .PartnershipIBTreeTable__PageInput {
    width: 50px;
    height: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    text-align: center;
    text-align-last: center;
    font-size: 13px;
    color: #333;
    padding: 0;
    outline: none;
    -moz-appearance: textfield;
  }

  .PartnershipIBTreeTable__PageInput::-webkit-outer-spin-button,
  .PartnershipIBTreeTable__PageInput::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .PartnershipIBTreeTable__PageInput:focus {
    border-color: #2fa7dc;
  }

  .PartnershipIBTreeTable__PageBtns {
    display: flex;
    gap: 8px;
  }
`;
